// extracted by mini-css-extract-plugin
export default {"bodyContainer":"Home_bodyContainer__axy5w","container":"Home_container__yeDhg","containerHead":"Home_containerHead__EMQJp","bloque":"Home_bloque__ddW5G"};